import useIsMobile from '@/hooks/useIsMobile'
import { HeadingLabel, MetaDataLabel } from '@/styles/fonts'
import { GrandstandIcon } from '@grandstand-web/bally-web-shared/src/components/GrandstandIcon'
import { AnalyticServiceContext } from '@grandstand-web/bally-web-shared/src/services/analytics/AnalyticService'
import { UserServiceContext } from '@grandstand-web/bally-web-shared/src/services/user/UserService'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { GrandstandButton } from '../Buttons'

type ConnectTVProviderProps = {
  onBack: () => void
}

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
`
const Header = styled(HeadingLabel)`
  border-bottom: 1px solid var(--divider-canvas);
  padding-bottom: 25px;
  padding-left: 25px;
  padding-top: 25px;
  div {
    float: left;
    top: 3px;
    right: 10px;
    position: relative;
    @media (min-width: 768px) {
      display: none;
    }
  }
`
const ArrowIcon = styled(GrandstandIcon)``
const FieldWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 24px;
  @media (min-width: 1000px) {
    justify-content: space-between;
  }
  @media (max-width: 999px) {
    flex-direction: column-reverse;
  }
`
const FieldDiv = styled.div`
  @media (max-width: 1000px) {
    text-align: center;
    margin-top: 10px;
  }

  button {
    margin-top: 20px;
    width: 30%;
  }
`
const FieldLabel = styled(MetaDataLabel)`
  color: var(--on-background-alt);
`
const FieldDivider = styled.div`
  width: 100%;
  height: 0px;
  border-top: 1px solid var(--divider-canvas);
`
const SubmitButtonWithProvider = styled(GrandstandButton)`
  width: 100%;
  margin: 24px 0px;
`

const ConnectTVProvider = ({ onBack }: ConnectTVProviderProps) => {
  const userService = useContext(UserServiceContext)
  const analyticService = useContext(AnalyticServiceContext)
  const profile = userService.currentUser?.profile
  const mvpd = userService.currentUser?.profile.mvpd
  const [currentProviderName, setCurrentProviderName] = useState('')
  const [currentProviderLogo, setCurrentProviderLogo] = useState('')
  const router = useRouter()
  const isMobile = useIsMobile()

  const handleBackClick = () => {
    if (isMobile) {
      router.push('/settings')
      onBack()
    }
  }

  const isLightMode = document.documentElement.getAttribute('data-theme') === 'light'

  useEffect(() => {
    const getProvider = async () => {
      let providerName = userService.currentUser?.profile.mvpd?.provider
      let providerLogo = isLightMode
        ? userService.currentUser?.profile.mvpd?.logos.light
        : userService.currentUser?.profile.mvpd?.logos.dark
      if (providerName) {
        setCurrentProviderName(providerName)
      }
      if (providerLogo) {
        setCurrentProviderLogo(providerLogo)
      }
    }
    getProvider()
  }, [isLightMode, userService.currentUser?.profile.mvpd])

  const onSignInWithProvider = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    router.push('/mvpd/signin')
  }

  const handleSignOut = async () => {
    // analyticService.logout()
    await userService.logOutMVPD()
    await userService.refresh()
  }

  return (
    <MainContent>
      <Header onClick={handleBackClick} fontSize="4">
        <ArrowIcon icon="arrow_left" /> TV Provider
      </Header>
      {profile && mvpd && (
        <FieldWrapper>
          <FieldDiv>
            <FieldLabel fontSize="sm">You are currently signed in to your TV provider. </FieldLabel>
            <GrandstandButton onClick={handleSignOut} buttonStyle="alt" buttonSize="xs">
              SIGN OUT
            </GrandstandButton>
          </FieldDiv>
          <FieldDiv>
            {currentProviderLogo ? (
              <Image src={currentProviderLogo} width={100} height={50} alt={currentProviderName} />
            ) : (
              currentProviderName
            )}
          </FieldDiv>
        </FieldWrapper>
      )}
      {profile && !mvpd && (
        <FieldWrapper>
          <div>
            <form onSubmit={onSignInWithProvider}>
              <FieldLabel fontSize="sm">Do you get FanDuel Sports Network through your TV Provider?</FieldLabel>
              <SubmitButtonWithProvider buttonStyle="primary" buttonSize="sm" type="submit">
                CONNECT TV PROVIDER
              </SubmitButtonWithProvider>
            </form>
          </div>
        </FieldWrapper>
      )}

      <FieldDivider />
    </MainContent>
  )
}
export default ConnectTVProvider
